import React from 'react'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { EntityBorderGroup } from 'src/editor/shared/settings/wrappers/border-groups/entity-border-group'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { FormLayoutSwitcher } from './form-layout-switcher'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'

interface FormDesignSettingsProps {
  entity: FormInterface
}

export const FormDesignSettings = ({ entity }: FormDesignSettingsProps) => {
  const updateProp = useUpdateProp(entity)

  const { isMobile } = useDeviceModeContext()
  return (
    <>
      {!isMobile && (
        <>
          <GroupTitle withoutHorizontalLine>
            entity_settings.form.layout
          </GroupTitle>
          <FormLayoutSwitcher
            className="mt-4"
            value={entity.layout}
            update={updateProp('layout')}
          />
        </>
      )}

      <ColorPickerControl
        label="settings_styles.background_color.label"
        color={entity.backgroundColor}
        update={updateProp('backgroundColor')}
        mobileColor={entity.mobileBackgroundColor}
        mobileUpdate={updateProp('mobileBackgroundColor')}
      />

      <EntityBorderGroup
        entity={entity}
        propertyKey="border"
        mobilePropertyKey="mobileBorder"
      />

      <SizeAndPositionGroup
        padding={isMobile ? entity.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />

      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
